import InitState from './states/InitState'
import LoadingState from "@/states/states/LoadingState";
import IdleState from './states/IdleState'
import StateMachine from "@state/StateMachine";
import {Signals} from "@/Imports";
import OpenSocketState from "@/states/states/OpenSocketState";
import RoundStartState from "@/states/states/RoundStartState";
import RoundEndState from "@/states/states/RoundEndState";
import MakeBetsState from "@/states/states/MakeBetsState";
import ReconnectSocketState from "@/states/states/ReconnectSocketState";
import FeatureStartState from "./states/FeatureStartState";
import FeatureStopState from "./states/FeatureStopState";

export default class GameStateMachine extends StateMachine {
  constructor (model, stateEnum) {
    super(model, stateEnum)
  }

  init(gameStatesEnum) {
    super.init(gameStatesEnum)
    this.addState(OpenSocketState, this.statesEnum.OPEN_SOCKET)
    this.addState(InitState, this.statesEnum.INIT)
    this.addState(LoadingState, this.statesEnum.LOADING)
    this.addState(IdleState, this.statesEnum.IDLE)
    this.addState(MakeBetsState, this.statesEnum.MAKE_BETS)
    this.addState(RoundStartState, this.statesEnum.ROUND_START)
    this.addState(RoundEndState, this.statesEnum.ROUND_END)
    this.addState(FeatureStartState, this.statesEnum.START_FEATURE)
    this.addState( FeatureStopState, this.statesEnum.STOP_FEATURE)
    this.addState(ReconnectSocketState, this.statesEnum.RECONNECT_SOCKET)
  }

  stateChanged(id, model) {
    super.stateChanged(id, model)
    console.log('STATE CHANGED:', id)
    Signals.stateChanged.dispatch(id, model)
  }
}
